// 导入请求数据的 request 模块
import request from '@/utils/request'

// 查询名人录信息
export const selectCelebrity = (currentPage, pageSize) => {
  return request.get('/celebrity/select', {
    params: {
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据学校名称查询名人录信息
export const getCelebritySchool = (school, currentPage, pageSize) => {
  return request.get('/celebrity/select/school', {
    params: {
      school: school,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据老师姓名查询名人录信息
export const getCelebrityTeacher = (teacher, currentPage, pageSize) => {
  return request.get('/celebrity/select/teacher', {
    params: {
      teacher: teacher,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据id查询名人录信息
export const getCelebrityTeacherById = (id) => {
  return request.get('/celebrity/select/id', {
    params: {
      id: id
    }
  })
}

// 为老师点赞
export const likeTeacherAPI = (id) => {
  return request.get('/celebrity/select/like', {
    params: {
      id: id
    }
  })
}
